export const REAL_INCOME_ASSET_TYPE = 'rfs';
export const REAL_INCOME_ASSET_WITH_GROSS_UP_TYPE = 'rfs-gu';

export const REAL_INCOME_CREATOR_OPTIONS = [
  {
    value: '1',
    label: '% CDI',
    showPercentage: true,
    index: 'cdi',
    percent: null,
    accrual: '0',
    createName: (tax: number | string) => `${tax}% CDI`,
  },
  {
    value: '2',
    label: 'CDI +',
    index: 'cdi',
    showPercentage: false,
    percent: '100',
    accrual: null,
    createName: (tax: number | string) =>
      `CDI ${Number(tax) > 0 ? '+' : '-'}${tax}%`,
  },
  {
    value: '3',
    label: 'Pré Fixado (%a.a.)',
    index: 'pre',
    showPercentage: true,
    percent: '100',
    accrual: '',
    createName: (tax: number | string) => `PRE +${tax}%a.a.`,
  },
  {
    value: '4',
    label: 'IPCA +',
    index: 'ipca',
    showPercentage: false,
    percent: '100',
    accrual: null,
    createName: (tax: number | string) =>
      `IPCA ${Number(tax) > 0 ? '+' : '-'}${tax}%`,
  },
  {
    value: '5',
    label: 'IGP-M +',
    index: 'igp-m',
    showPercentage: false,
    percent: '100',
    accrual: null,
    createName: (tax: number | string) =>
      `IGP-M ${Number(tax) > 0 ? '+' : '-'}${tax}%`,
  },
  {
    value: '6',
    label: 'DOLAR +',
    index: 'dolar',
    showPercentage: false,
    percent: '100',
    accrual: null,
    createName: (tax: number | string) =>
      `DOLAR ${Number(tax) > 0 ? '+' : '-'}${tax}%`,
  },
];

export const REAL_INCOME_KEY_WORDS_SEARCH = [
  'ren',
  'rend',
  'rend',
  'renda',
  'fix',
  'fixa',
  'cdb',
  'rdb',
  'cdi',
  'lci',
  'lca',
  'cri',
  'cra',
  'deb',
  'debe',
  'deben',
  'debent',
  'debentu',
  'debentur',
  'debenture',
  'ipc',
  'ipca',
  'igp',
  'igpm',
  'lc',
  'lf',
  'lig',
  'poup',
  'poupa',
  'poupan',
  'poupanc',
  'poupanca',
];

export const GROSS_UP_OPTIONS = [
  { value: null, label: 'Nenhum' },
  { value: 22.5, label: '22,5%' },
  { value: 20, label: '20%' },
  { value: 17.5, label: '17.5%' },
  { value: 15, label: '15%' },
];

// export const FIXED_INCOME_CHOICES = [
//   { label: 'CDB', value: 'CDB' },
//   { label: 'RDB', value: 'RDB' },
//   { label: 'LCI', value: 'LCI' },
//   { label: 'LCA', value: 'LCA' },
//   { label: 'DEBENTURE', value: 'DEBENTURE' },
//   { label: 'CRI', value: 'CRI' },
//   { label: 'CRA', value: 'CRA' },
//   { label: 'LIG', value: 'LIG' },
//   { label: 'LC', value: 'LC' },
//   { label: 'LF', value: 'LF' },
// ];
